import { useState } from 'react';
import { CommonProps, StylesConfig } from 'react-select';
import Creatable from 'react-select/creatable';
import * as Styles from './AutoCompleteDropdown.styles';
import WarningMessage from '../WarningMessage';

export type DropdownOption = {
  value: string;
  label: string;
};

type CustomProps = {
  isDisabled?: boolean;
  onCreateOption?: (value: string) => void;
  options: DropdownOption[];
  closeMenuOnSelect?: boolean;
  isLoading?: boolean;
  value?: DropdownOption[];
  onChange?: (e: any) => void;
  name: string;
  label?: string;
  errorMessage?: string;
  isOptionDisabled?: () => boolean;
  creatableStyles?: StylesConfig<DropdownOption, boolean>;
  allowCreateWhileLoading?: boolean;
  isValidNewOption?: (inputValue: string, value: any, options: any, accessors: any) => boolean;
};

export type AutoCompleteDropdownProps = Partial<CommonProps<any, any, any>> & CustomProps;

export default function AutoCompleteDropdown({
  label,
  errorMessage,
  creatableStyles,
  allowCreateWhileLoading,
  isValidNewOption,
  ...props
}: AutoCompleteDropdownProps): JSX.Element {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  const handleOpen = (): void => {
    setIsOpen(true);
  };

  const handleClose = (): void => {
    setIsOpen(false);
  };

  return (
    <Styles.Box className={`auto-complete-dropdown ${isOpen ? 'is-opened' : ''}`}>
      {label && <Styles.Label>{label}</Styles.Label>}
      <Creatable
        {...props}
        styles={{ ...Styles.customComponentStyles, ...creatableStyles }}
        onMenuOpen={handleOpen}
        onMenuClose={handleClose}
        allowCreateWhileLoading={allowCreateWhileLoading}
        isValidNewOption={isValidNewOption}
      />
      <WarningMessage errorMessage={errorMessage} />
    </Styles.Box>
  );
}
